import type React from 'react';
import type { AutoSaveStatus } from '../hooks/useAutoSave';
import { getAutoSaveStatusDisplay } from './autoSaveStatusDisplay';

interface AutoSaveStatusIndicatorProps {
  status: AutoSaveStatus;
  className?: string;
}

export const AutoSaveStatusIndicator: React.FC<
  AutoSaveStatusIndicatorProps
> = ({ status, className = '' }) => {
  const display = getAutoSaveStatusDisplay(status);
  if (!display) return null;

  const { Icon, label, textClass, spin } = display;
  return (
    <div
      className={`flex items-center gap-1 text-xs ${className}`}
      aria-live='polite'
    >
      <span className={`${textClass} flex items-center gap-1`}>
        <Icon className={`h-3 w-3${spin ? ' animate-spin' : ''}`} />
        {label}
      </span>
    </div>
  );
};
